import { render, staticRenderFns } from "./FooterErrors.vue?vue&type=template&id=59d6a184&scoped=true&"
import script from "./FooterErrors.vue?vue&type=script&lang=js&"
export * from "./FooterErrors.vue?vue&type=script&lang=js&"
import style0 from "./FooterErrors.vue?vue&type=style&index=0&id=59d6a184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6a184",
  null
  
)

export default component.exports